// Distribución del estudio (Fase 9.2) a partir del resumen de supervisión.
//
// En pantalla las salas quedan en rombo: control arriba, cabinas a la derecha,
// lobby a la izquierda y asesores abajo. Así el recorrido de un caso se lee de
// arriba hacia abajo: SARA → lobby (cola) → asesor, y de vuelta a SARA al cerrar.
import { BOOTH, DESK_D, DESK_W, WALL_H } from './art';

const GAP = 2.2;   // con menos, las paredes de una sala tapan la de al lado
const BOOTH_CELL = BOOTH + 0.35;

export const ROOM_KEYS = ['control', 'booths', 'lobby', 'humans'];

export function computeLayout(data) {
  const controlAgents = data.ai_agents.filter(a => a.room === 'control');
  const boothAgents = data.ai_agents.filter(a => a.room !== 'control');
  const humans = data.humans;

  const nb = Math.max(1, boothAgents.length);
  const bCols = nb <= 3 ? nb : Math.ceil(nb / 2);
  const bRows = nb <= 3 ? 1 : 2;
  const nh = Math.max(1, humans.length);
  const hCols = Math.min(4, nh);
  const hRows = Math.ceil(nh / hCols);

  const CW = 6.5;
  const BW = Math.max(6, bCols * BOOTH_CELL + 0.5);
  const topD = Math.max(5, bRows * (BOOTH_CELL + 0.45) + 0.5);
  const HW = Math.max(6, hCols * DESK_W + 0.6);
  const botD = Math.max(5.2, hRows * DESK_D + 0.6);

  const rooms = {
    control: { key: 'control', x: 0, y: 0, w: CW, d: topD },
    booths: { key: 'booths', x: CW + GAP, y: 0, w: BW, d: topD },
    lobby: { key: 'lobby', x: 0, y: topD + GAP, w: CW, d: botD },
    humans: { key: 'humans', x: CW + GAP, y: topD + GAP, w: HW, d: botD },
  };

  const boothSlots = boothAgents.map((agent, i) => ({
    agent,
    x: rooms.booths.x + 0.3 + (i % bCols) * BOOTH_CELL,
    y: rooms.booths.y + 0.3 + Math.floor(i / bCols) * (BOOTH_CELL + 0.45),
  }));
  const deskSlots = humans.map((human, i) => ({
    human,
    x: rooms.humans.x + 0.3 + (i % hCols) * DESK_W,
    y: rooms.humans.y + 0.3 + Math.floor(i / hCols) * DESK_D,
  }));

  // Puntos (3D) de origen y destino de los casos que viajan entre salas
  const c = rooms.control;
  const l = rooms.lobby;
  const positions = {
    control: [c.x + c.w / 2, c.y + 2.6, 1.0],
    lobby: [l.x + l.w / 2, l.y + 2.2, 1.0],
  };
  deskSlots.forEach(s => { positions[`human:${s.human.id}`] = [s.x + 1.1, s.y + 1.4, 1.1]; });
  boothSlots.forEach(s => { positions[`agent:${s.agent.id}`] = [s.x + BOOTH / 2, s.y + 1.0, 1.2]; });

  return { rooms, controlAgents, boothSlots, deskSlots, positions };
}

/** Caja de pantalla (en unidades del SVG) que ocupan las salas indicadas. */
export function boundsOf(rooms, P, { top = 0, bottom = 0 } = {}) {
  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
  rooms.forEach(r => {
    [[r.x, r.y, WALL_H + 0.6], [r.x + r.w, r.y, WALL_H], [r.x, r.y + r.d, WALL_H], [r.x + r.w, r.y + r.d, -0.2], [r.x, r.y + r.d, -0.2], [r.x + r.w, r.y, -0.2]]
      .forEach(p => {
        const [sx, sy] = P(...p);
        minX = Math.min(minX, sx); maxX = Math.max(maxX, sx);
        minY = Math.min(minY, sy); maxY = Math.max(maxY, sy);
      });
  });
  const pad = 24;
  return { x: minX - pad, y: minY - pad - top, w: maxX - minX + 2 * pad, h: maxY - minY + 2 * pad + top + bottom };
}
